import React from "react";

const LoadingSpinner = ({ className }) => (
	<div className={className || ""}>
		<i className="fas fa-spinner fa-pulse"/>
	</div>
);

export default LoadingSpinner;
